import { useState } from 'react';
import { DropdownMenu, type DropdownMenuItem } from '../DropdownMenu';
import { Message, MessageStack } from '../Message';
import styles from './ProductNavigation.module.css';

const accountItems: readonly DropdownMenuItem[] = [
  { id: 'profile', label: '内置管理员', description: '账号：admin@test', leadingContent: <span aria-hidden="true" className={styles.profileAvatar}>Z</span>, trailingIcon: 'a-arrow-right' },
  { id: 'admin', label: '管理后台', icon: 'shezhi2', href: '#/admin', separatorBefore: true },
  { id: 'aira', label: 'AIRA工作台', icon: 'aira' },
  { id: 'bookmarks', label: '我的书签（8）', icon: 'shuqian1', trailingIcon: 'a-arrow-right' },
  { id: 'help', label: '帮助中心', icon: 'bangzhuzhongxin', hoverIcon: 'bangzhuzhongxin-hover' },
  { id: 'downloads', label: '下载中心', icon: 'xiazai5' },
  { id: 'feedback', label: '反馈/建议', icon: 'zaixianfankui1' },
  { id: 'store', label: '商店', icon: 'yingyong1' },
  { id: 'support', label: '技术支持授权码', icon: 'jishuzhichishouquanma' },
  { id: 'logout', label: '退出登录', icon: 'tuichuxuanzhong2', hoverIcon: 'tuichuxuanzhong1', hoverIconTone: 'danger', separatorBefore: true },
];

export function AccountMenu({ avatarSrc, onOpenChange }: { avatarSrc?: string; onOpenChange?: (open: boolean) => void }) {
  const [notice, setNotice] = useState('');
  const [noticeSequence, setNoticeSequence] = useState(0);
  const items = avatarSrc ? accountItems.map((item) => item.id === 'profile' ? { ...item, leadingContent: <img alt="" className={styles.profileAvatar} src={avatarSrc} /> } : item) : accountItems;
  return <>
    <DropdownMenu appearance="account" ariaLabel="当前用户菜单" arrow={false} items={items} onItemSelect={(item) => {
      if (item.href) return;
      setNotice(item.id === 'logout' ? '当前为设计预览，未执行退出登录' : `${item.label}页面待建设`);
      setNoticeSequence((value) => value + 1);
    }} onOpenChange={onOpenChange} trigger={<button className={styles.avatar} type="button">{avatarSrc ? <img alt="" className={styles.avatarImage} src={avatarSrc} /> : 'Z'}</button>} triggerMode="hover" />
    <MessageStack><Message key={noticeSequence} message={notice} onOpenChange={(open) => { if (!open) setNotice(''); }} open={Boolean(notice)} /></MessageStack>
  </>;
}
